import request from '@/utils/request'

export function epms6050(param) {
    let data = param
    return request({
        url: `/supplier/epms6050/epms6050`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function epms6050_att(param) {
    let data = param
    return request({
        url: `/supplier/epms6050/epms6050_att`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function uploadBasicContract(param) {
    let data = param
    return request({
        url: `/supplier/epms6050/uploadBasicContract`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'multipart/form-data' },
        data
    })
}

export function updateSmsInformation(param) {
    let data = param
    return request({
        url: `/supplier/epms6050/updateSmsInformation`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}


